import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',

    '& .screenWrapper_1': {
      flexDirection: (p) => (p.isMobile ? 'column' : 'row'),
    },
  },
  subScreen: {
    width: (p) => (p.isMobile ? '100%' : 'calc(50% - 10px)'),
  },
  title: {
    fontSize: '1rem',
    fontWeight: 'bold',
  },
  accordion: {
    '& .accordionRow': {
      border: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1),
      boxSizing: 'border-box',

      '&.notLast': {
        borderBottom: `none`,
      },

      '& .titlerow': {
        cursor: 'pointer',

        '& .MuiIcon-root': {
          marginLeft: 'auto',
        },
      },
    },
  },

  createSc: {
    '& .titleContainer': {
      maxWidth: 'none',
    },
    height: '100%',
    padding: theme.spacing(2),
  },

  container: {
    position: 'relative',
    padding: (p) => (p.isMobile ? 0 : theme.spacing(4)),
    maxWidth: 900,
    margin: '0 auto',

    '& .noBorder td': {
      border: 'none',
    },

    '& .offsetCheck': {
      position: 'relative',
      left: 15,
      padding: 0,
    },
  },
  flexRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: `${theme.spacing(2)} 0`,
  },
  flexColumn: {
    flexDirection: 'column',
  },
  pad20: {
    padding: (p) => (p.isMobile ? 0 : 20),
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '0 auto',
  },
  formControl: {
    width: 250,
    marginRight: theme.spacing(2),
  },
  buttonRow: {
    '& button': {
      marginRight: theme.spacing(2),
    },
  },
  table: {
    width: '100%',

    '& table': {
      width: '100%',
    },
    '& td': {
      fontSize: 12,
    },
    '& tr': {
      cursor: 'pointer',

      '& .parentIcon': {
        transform: 'rotate(90deg)',
        fontSize: 10,
        marginTop: -8,
        marginRight: theme.spacing(0.5),
      },
    },
  },
  margBottom: {
    marginBottom: theme.spacing(2),
  },
  smallMarginTopBottom: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  iconSpacing: {
    marginRight: theme.spacing(1),
  },
  manage: {
    '& .mainContainer': {
      marginTop: theme.spacing(2),
    },
    '& .buttonRow': {
      flexWrap: 'wrap',
    },
    '& .buttonRow button': {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      maxHeight: 33,
    },
  },
  formStyle: {
    maxWidth: 'none',

    '& .MuiInput-root.MuiInput-underline.Mui-disabled:before': {
      borderBottom: 'none',
    },
  },
  addedition: {
    '& .buttonContainer': {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: 60,
      boxShadow: '2px 2px 8px',
      backgroundColor: theme.palette.background.paper,
      zIndex: 100,

      '& .buttonRow': {
        height: 60,
        justifyContent: 'space-around',
      },
    },

    '& .listButtons': {
      marginTop: theme.spacing(2),

      '& button': {
        margin: theme.spacing(1),
      },
    },

    '& .docText': {
      margin: theme.spacing(1),
    },

    '& .buffer': {
      height: 60,
      width: 'calc(100% - 300px)',
      float: 'right',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        float: 'none',
        position: 'relative',
      },
    },
  },
  searchBar: {
    marginLeft: 0,
    marginRight: 0,
    marginTop: theme.spacing(2),
  },
  buttonRowModal: {
    position: 'absolute',
    bottom: 12,
    justifyContent: 'flex-end',
    padding: theme.spacing(1),
    maxWidth: 640,
    width: '100%',
    boxSizing: 'border-box',
    margin: '0 auto',

    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
}));

export default useStyles;
